import { store } from "@src/store";
import { clone } from "@shared/utils";
import CacheUtil from "@shared/modules/utils/CacheUtil";
const CACHE = new CacheUtil("DataStore");

const setUserMeta = () => {};

const DataStore = {
    data: {
        tenant: "",
        tenantCode: "",
        user: {},
        prefs: {
            lang: "en",
            langFloat: "left"
        },
        features: [],
        flags: {},
        registration: {
            validSession: false,
            active: false
        },
        refundPendingTrnxDetails: null,
        faceLoginServiceBaseUrl: null,
        cdnUrl: null,
        jaxProperty: {},
        device: {},
        custLastYrTrnxDet: null
    },

    async init() {
        if (window.userMeta) {
            this.setUserMeta(window.userMeta);
        }

        this.dataStr = JSON.stringify(this.data);

        return "done";
    },

    reset() {
        this.data = JSON.parse(this.dataStr);
    },

    setData(data) {
        this.data = clone(data);
    },

    setFlagInfo(data) {
        this.data.flags = data.flags || this.data.flags;
    },

    getFlagInfo() {
        return this.data.flags || {};
    },

    getData() {
        return this.data;
    },

    getFeatures() {
        return this.data.features || [];
    },

    getDevice() {
        return this.data.device || {};
    },

    setUserMeta(data) {
        this.data.user = data || this.data.user;
        store.dispatch(setUserMeta(data || this.data.user));
    },

    setFeatures(data) {
        this.data.features = data || this.data.features;
    },

    getUserMeta() {
        return this.data.user || {};
    },

    setConfig(data) {
        this.data.config = data || this.data.config;
    },

    setLang(lang) {
        var _lang = (this.data.prefs.lang = lang || this.data.prefs.lang);
        window.localStorage.setItem("lang", _lang);
        CACHE.setVal("lang", _lang);
        return _lang;
    },

    setRegistrationData({ validSession, active }) {
        this.data.registration.validSession = validSession || this.data.registration.validSession;
        this.data.registration.active = active || this.data.registration.active;
    },

    setUserData(data) {
        this.data.user = data || this.data.user;
    },

    setDomCur(data) {
        this.data.domCurrency = data || this.data.domCurrency;
    },

    setTenantInfo(data) {
        this.data.tenantCode = data.tenantCode || this.data.tenantCode;
        this.data.tenant = data.tenant || this.data.tenant;
    },

    setRefundStatus(data) {
        this.data.refundPendingTrnxDetails = data.refundPendingTrnxDetails || this.data.refundPendingTrnxDetails;
    },

    setFaceLoginServiceBaseUrl(data) {
        this.data.faceLoginServiceBaseUrl = data.faceLoginServiceBaseUrl || this.data.faceLoginServiceBaseUrl;
    },

    setJaxProperty(data) {
        this.data.jaxProperty = data.jaxProperty || this.data.jaxProperty;
    },

    setDeviceData(data) {
        // ARMS500 to ARMS544 LOT1 (Old IBS Machines)
        // ARMS545 to ARMS610 LOT2 (New IBS Machines)
        this.data.device = { ...data.device, lot: data.flags?.kioskType || "LOT1" };
    },

    setCDNUrl(data) {
        this.data.cdnUrl = data.cdnUrl || this.data.cdnUrl;
    },

    getLastYearTransactionDetails() {
        return this.data?.custLastYrTrnxDet || {};
    },

    setLastYearTransactionDetails(data) {
        this.data.custLastYrTrnxDet = data?.custLastYrTrnxDet || this.data.custLastYrTrnxDet
    }
};

export default DataStore;
